import { useStorage } from '@vueuse/core'

const currentEnvironment = useStorage('currentEnvironment', 'default')

/**
 * @param {string} url
 * @param {Record<string, string>} queryParams
 * @returns {Promise<any>}
 */
const get = async (url, queryParams = {}) => {
  const params = new URLSearchParams(queryParams)
  return fetch(url + (params.size ? '?' + params : ''), {
    headers: {
      'X-Environment': currentEnvironment.value,
      Accept: 'application/json'
    }
  }).then(x => x.json())
}

/**
 * @param {string} url
 * @param {any} data
 * @param {any} toast
 * @returns {Promise<any>}
 */
const post = async (url, data, toast = null) => {
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'x-environment': currentEnvironment.value,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: data ? JSON.stringify(data) : undefined
  })
  if (!res.ok) {
    let msgText = res.statusText + '\n'
    try {
      msgText += (await res.json()).message
    } catch (error) {}
    if (toast) toast.add({ severity: 'error', group: 'tr', summary: 'Error', detail: 'An error occurred: ' + msgText })
    throw new Error(msgText)
  }
  return res.status === 201 || res.status === 204 ? res : res.json()
}

/**
 * @param {string} url
 * @param {any} data
 * @param {any} toast
 * @returns {Promise<any>}
 */
const put = async (url, data, toast = null) => {
  const res = await fetch(url, {
    method: 'PUT',
    headers: {
      'x-environment': currentEnvironment.value,
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: data ? JSON.stringify(data) : undefined
  })
  if (!res.ok) {
    let msgText = res.statusText + '\n'
    try {
      msgText += (await res.json()).message
    } catch (error) {}
    if (toast) toast.add({ severity: 'error', group: 'tr', summary: 'Error', detail: 'An error occurred: ' + msgText })
    throw new Error(msgText)
  }
  return res.status === 201 || res.status === 204 ? res : res.json()
}

/**
 * @param {string} url
 * @returns {Promise<any>}
 */
const deleteCall = async (url) => {
  const res = await fetch(url, {
    method: 'DELETE',
    headers: {
      'x-environment': currentEnvironment.value,
      Accept: 'application/json'
    }
  })
  if (res.status === 204) return res
  return res.json()
}

export default {
  oauth: {
    logout: () => get('/oauth/logout'),
  },
  webauthn: {
    /**
     * @param {string} userId
     * @returns {Promise<any>}
     */
    getAuthenticationOptions: userId => get('/webauthn/authentication-options', { userid: userId }),
    getRegistrationOptions: () => get('/webauthn/registration-options')
  },
  anomalies: {
    /**
     * @param {{ startDate: string, endDate: string }} param0
     * @returns {Promise<SwaggerModels.AnomaliesInner[]>}
     */
    getAnomalies: ({ startDate, endDate }) => get('/hk/v1/anomalies', { startDate, endDate }),
    /**
     * @param {number} anomalyId
     * @returns
     */
    getAnomaly: async (anomalyId) => get(`/hk/v1/anomalies/${anomalyId}`)
  },
  settings: {
    /**
     * @returns {Promise<SwaggerModels.GetEnvironmentResInner[]>}
     */
    getEnvironments: () => get('/hk/v1/environments'),
    getSettings: () => get('/hk/v1/settings'),
  },
  stats: {
    /**
     * @returns {Promise<SwaggerModels.DashboardStats>}
     */
    getDashboard: () => get('/hk/v1/stats/dashboard')
  },
  deploy: {
    getDeployInfo: (fromEnv, toEnv) => get(`/hk/v1/deploy/from/${fromEnv}/to/${toEnv}`),
    getDeployInfoFromHerokuConnect: (hkPayload, toEnv, toast) => put(`/hk/v1/deploy/from/json/to/${toEnv}`, hkPayload, toast),
    deploy: (fromEnv, toEnv, data, toast) => post(`/hk/v1/deploy/from/${fromEnv}/to/${toEnv}`, data, toast)
  },
  odata: {
    getTables: () => get('/hk/v1/odata/tables'),
    getConfig: () => get('/hk/v1/odata/config'),
    saveConfig: (config) => post('/hk/v1/odata/config', config)
  },
  get,
  post,
  delete: deleteCall
}
